import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as apiOrdersService from '../../services/apiOrdersService'
import Currency from './currency'
import { BASE_IMAGE_PATH } from '../../configs/api';
import * as dateUtil from "../../util/date.util"
import moment from 'moment';
class SettledMarketsPnLModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
      };
   }
   componentDidMount() {
   }
   closePopup() {
      this.setState({ from: "", to: "", showData: false, orders_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, records_display: 25 })
      this.props.hidePopupBets()
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value });
   }
   render() {
      
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                     {!!this.props.sportAnalysisEventDetails ? 
                        <h4 className="modal-title">Settled Markets P&L</h4>
                     :
                        <h4 className="modal-title">{!!this.props.selectedMarketList && !!this.props.selectedMarketList.marketList && this.props.selectedMarketList.marketList.length > 0 ? this.props.selectedMarketList.marketList[0].eventName : '' }</h4>
                     }
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop pt-0">
                        {/* {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}><img alt="" style={{width: "45px"}} src={BASE_IMAGE_PATH + "/aimg/loader.gif"}></img></div> : null} */}
                        <div>
                        {!!this.props.sportAnalysisEventDetails &&
                        <>
                           <div className='d-flex justify-content-between small text-black mt-2'>
                              <span><span>{this.props.sportAnalysisEventDetails.eventId} - {this.props.sportAnalysisEventDetails.eventName}</span> <i className='fa fa-refresh text-success ml-1 cursor-pointer' title='Refresh' onClick={()=>this.props.onShowPnLReportMarketPopup()}></i></span>
                              <span>{this.props.sportAnalysisEventDetails.compId} - {this.props.sportAnalysisEventDetails.compName}</span>
                           </div>
                           {/* <div>
                              List Data:resultDetail[0].actionTime
                           </div> */}
                        </>
                        }
                           <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className="table-responsive">
                                    <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2">
                                       <thead>
                                          <tr>
                                          {!!this.props.selectedMarketList && !!this.props.selectedMarketList.marketList && this.props.selectedMarketList.marketList.length > 0 && this.props.selectedMarketList.marketList[0].eventTypeId === '99'?
                                          <th className="pthead">Date &amp; Time</th>
                                          :
                                             <th className="pthead">Market</th>}
                                             <th className="pthead">Declare Date & Time</th>
	                                          <th className="pthead">Winner</th>
                                             <th className="text-right pthead">Order Count</th>
                                             <th className="text-right pthead">Total Amount</th>
                                             <th className="text-right pthead" title="Profit/Loss">P/L</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {
                                             !!this.props.selectedMarketList && !!this.props.selectedMarketList.marketList && this.props.selectedMarketList.marketList.length > 0 ? 
                                             
                                             <>
                                             
                                                <tr key={"Total"}>
                                                   <td className="text-right" colSpan={3}><b>Total</b></td>
                                                   <td className="text-right"><b>{this.props.selectedMarketList.totalOrderCnt}</b></td>
                                                   <td className="text-right"><Currency key={"totalstakes"} className={!!this.props.selectedMarketList && !!this.props.selectedMarketList.totalStakes && this.props.selectedMarketList.totalStakes < 0 ? "fbold text-red" :"fbold text-green"} amount={this.props.selectedMarketList.totalStakes} showColor={false} /></td>
                                                   <td className="text-right"><Currency key={"totalpnl"} className={!!this.props.selectedMarketList && !!this.props.selectedMarketList.totalPnL && this.props.selectedMarketList.totalPnL < 0 ? "fbold text-red" :"fbold text-green"} amount={this.props.selectedMarketList.totalPnL} showColor={false} /></td>
                                                </tr>
                                                {this.props.selectedMarketList.marketList.map((evnt_itm, i) => {
                                                   let dt = new Date(evnt_itm.createdAt).toLocaleString("hi-IN");
                                                   if(evnt_itm.eventTypeId === '300'){
                                                      evnt_itm.market_time =  dateUtil.getBinaryMarketDisplayName(evnt_itm.marketName)
                                                        }
                                                   return (
                                                      <tr key={i}>
                                                         {evnt_itm.eventTypeId === '99'?
                                                         <td>{dt}</td>
                                                         :
                                                         <td title={evnt_itm.eventName}>{evnt_itm.marketId} - {evnt_itm.eventTypeId === '300' && !!evnt_itm.market_time && evnt_itm.market_time.length > 0 ? 
                                                            <>
                                                            {evnt_itm.market_time[0] }
                                                            <span className=''> [<b>{(evnt_itm.market_time.length > 0 ? evnt_itm.market_time[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!evnt_itm.marketName ? evnt_itm.marketName : "-"}</td>}
                                                         <td>{!!evnt_itm.resultDetail && evnt_itm.resultDetail.length > 0 ? moment(evnt_itm.resultDetail[0].actionTime + "+00:00").format('DD MMM YYYY HH:mm:ss') : ''}</td>
                                                         <td>{evnt_itm.winnerName}</td>
                                                         <td className="text-right">{evnt_itm.orderCount}</td>
                                                         <td className="text-right"><Currency key={"stakes_" + i} className={!!evnt_itm.totalAmount && parseFloat(evnt_itm.totalAmount) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.totalAmount} showColor={false} /></td>
                                                         <td className="text-right"><Currency key={"pnl_" + i} className={!!evnt_itm.pnl && parseFloat(evnt_itm.pnl) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.pnl} showColor={false} /></td>
                                                      </tr>
                                                   );
                                                })}
                                                </>
                                              : <tr>
                                                      <td colSpan={26} align="center">
                                                      {!!this.props.sportAnalysisEventDetails ? 
                                                         "No Result Declared Yet."
                                                      :
                                                         "No Data Found."
                                                      }
                                                      </td>
                                                   </tr>
                                          }
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.closePopup() }}></div>
               </div>            
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(SettledMarketsPnLModel);